import axios from './axios'
import config from '../config'

function openEventPage(event) {
    let url
    switch (event.type) {
        case '舆情':
            url = [document.location.origin, document.location.pathname,
                '#/main/company-alarm-news/', encodeURIComponent(event.sourceId)
            ]
            break
        case '行政处罚':
            url = [document.location.origin, document.location.pathname,
                '#/main/penalties/', encodeURIComponent(event.sourceId)
            ]
            break
        default:
            url = [document.location.origin, document.location.pathname,
                '#/main/company-risk-events/', encodeURIComponent(event.id)
            ]
            break
    }
    window.open(url.join(''), '_blank')

}

function openCompanyPage(id) {
    const url = [document.location.origin, document.location.pathname,
        '#/main/companies/', id
    ]
    window.open(url.join(''), '_blank')
}

export default {
    countEventsByType(params) {
        return axios({
            url: config.backendUrl + '/project/company-risk-events/count-events-by-type',
            method: 'GET',
            params
        })
    },
    listAllMonitoredCompanySummaries(params) {
        return axios({
            url: config.backendUrl + '/project/company-risk-events/list-all-monitored-company-summaries',
            method: 'GET',
            params
        })
    },
    countEventAndCompanyMonthly(params) {
        return axios({
            url: config.backendUrl + '/project/company-risk-events/count-event-and-company-monthly',
            method: 'GET',
            params
        })
    },
    listCompanyRiskEvents(params) {
        return axios({
            url: config.backendUrl + '/project/company-risk-events',
            method: 'GET',
            params
        })
    },
    listRelationCompanySummaries(params) {
        return axios({
            url: config.backendUrl + '/project/company-risk-events/list-relation-company-summaries',
            method: 'GET',
            params
        })
    },
    listDpsCompanies(params) {
        return axios({
            url: config.backendUrl + '/project/dps-companies',
            method: 'GET',
            params
        })
    },
    listMonitoredCompanies(params) {
        return axios({
            url: config.backendUrl + '/project/monitored-companies',
            method: 'GET',
            params
        })
    },
    addMonitoredCompany(data) {
        return axios({
            url: config.backendUrl + '/project/monitored-companies',
            method: 'POST',
            data
        })
    },
    updateReport(data) {
        return axios({
            url: config.backendUrl + '/project/reports',
            method: 'PUT',
            data
        })
    },
    getPenalty(id) {
        return axios({
            url: config.backendUrl + '/project/company-risk-events/penalties/' + encodeURIComponent(id),
            method: 'GET'
        })
    },
    getNews(sid) {
        return axios({
            url: config.backendUrl + '/project/company-risk-events/news/' + encodeURIComponent(sid),
            method: 'GET'
        })
    },
    deleteMonitoredCompany(id) {
        return axios({
            url: config.backendUrl + '/project/monitored-companies/' + id,
            method: 'DELETE'
        })
    },
    getDpsCompanyBasicInfo(id) {
        return axios({
            url: config.backendUrl + '/project/dps-companies/' + id + '/basic-info',
            method: 'GET'
        })
    },
    getDpsCompanyIcBasicInfo(id) {
        return axios({
            url: config.backendUrl + '/project/dps-companies/' + id + '/ic-basic-info',
            method: 'GET'
        })
    },
    getDpsCompanyStockDetails(id) {
        return axios({
            url: config.backendUrl + '/project/dps-companies/' + id + '/stock-details',
            method: 'GET'
        })
    },
    openEventPage,
    openCompanyPage
}
